import './OrderEvents.css';
import { ApiOrderEvent, VisibleOrderStatus } from '../../types';
import { useFormatting } from '../../i18n/i18n';
import { useTranslation } from '../../i18n/i18n';
import { Table } from '../Table/Table';

export const OrderEvents = ({ orderEvents }: { orderEvents: ApiOrderEvent[] }): JSX.Element => {
	const t = useTranslation().orderPages;
	return (
		<Table striped>
			<thead>
				<tr>
					<th>{t.date}</th>
					<th>{t.event}</th>
				</tr>
			</thead>
			<tbody>
				{orderEvents.map((orderEvent) => (
					<OrderEvent key={orderEvent.id} orderEvent={orderEvent} />
				))}
			</tbody>
		</Table>
	);
};

const OrderEvent = ({ orderEvent }: { orderEvent: ApiOrderEvent }): JSX.Element => {
	const t = useTranslation().orderPages;
	const { dateTimeFormat } = useFormatting();

	let visibleStatus = orderEvent.status as VisibleOrderStatus;

	if (t.visibleOrderStatus[visibleStatus]) {
		return (
			<tr>
				<td>{dateTimeFormat(new Date(orderEvent.dateCreated))}</td>
				<td>{t.visibleOrderStatus[visibleStatus]}</td>
			</tr>
		);
	} else {
		return <></>;
	}
};
